import FormField from "../../components/FormField";
import TextInput from "../../components/TextInput";

const Keywords = ({ handleInputChange, values }) => {
  const locationData = values?.location || {};

  return (
    <div className="wsm-keyword-grid">
      {Array.from({ length: 6 }, (_, index) => {
        const number = index + 1;
        const name = `keyword_${number}`;
        return (
          <FormField id={`location--${name}`} key={name} label={`Keyword ${number}`} optional>
            {(fieldProps) => (
              <TextInput
                {...fieldProps}
                name={name}
                onChange={(event) => handleInputChange(`location.${name}`, event.target.value)}
                value={locationData[name] || ""}
              />
            )}
          </FormField>
        );
      })}
    </div>
  );
};

export default Keywords;